import { useTranslation } from "@flare/i18n";

import { LssScheduler } from "@/components/Funnel/lss-scheduler/lss-scheduler";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { InputsContainer } from "../components/inputs-container";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";

import type { StepProps } from "./step.types";

export default function BookLss({ answers }: StepProps) {
  const { practice, leadSource } = answers;
  const { t } = useTranslation();

  const funnelSubtitle =
    practice === "family"
      ? t("FUNNEL_BOOK_LSS_SUBTITLE_FAMILY")
      : t("FUNNEL_BOOK_LSS_SUBTITLE_IMM");

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle className="md:mt-sp-4">
            {t("FUNNEL_BOOK_LSS_TITLE_V1")}
          </StepTitle>
          <StepSubtitle className="mb-sp-0 mt-sp-1 max-w-full">
            {leadSource === "legal-plan"
              ? t("LEGAL_PLAN_BOOK_LSS_SUBTITLE_FAMILY")
              : funnelSubtitle}
          </StepSubtitle>
          <InputsContainer className="my-sp-4 flex h-[calc(100svh-353px)] min-h-[280px] w-full max-w-[560px] flex-col md:h-[calc(100svh-388px)]">
            <LssScheduler />
          </InputsContainer>
        </StepContent>
        <ActionsContainer>
          <ActionButton>Next</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
